export enum DataFormType {
    Documents,
    FinancialRequest,
    Questionnaire,
    DataTable,
}